import type { ICommand } from "./ICommand";
import type { DRDrawingViewer } from "../DRDrawingViewer";
import type { DrawingModule } from "../types/DrawingWeb";
import { deleteObj } from "../core/delete";
import { findEntityByHandle } from "../core/oda";
import { selectionService } from "../selection";
import { oplogEmitter, type OplogEmit } from "../meta/oplog";

export interface ITextHeightOperator {
  setTextHeight(entityId: DrawingModule.OdDbObjectId, height: number): boolean;
  viewer: DRDrawingViewer;
}

export interface SetTextHeightParams {
  handle: string;
  oldHeight: number;
  newHeight: number;
}

export class SetTextHeightCommand implements ICommand {
  private operator: ITextHeightOperator;
  private handle: string;
  private oldHeight: number;
  private newHeight: number;
  private oplogEvents: OplogEmit[] = [];

  constructor(operator: ITextHeightOperator, params: SetTextHeightParams) {
    this.operator = operator;
    this.handle = params.handle;
    this.oldHeight = params.oldHeight;
    this.newHeight = params.newHeight;
  }

  execute(): void {
    this.oplogEvents = oplogEmitter.emitModified(this.operator.viewer, [
      {
        handle: this.handle,
        changeKind: "height",
        oldValue: String(this.oldHeight),
        newValue: String(this.newHeight),
      },
    ]);
  }

  undo(): void {
    this.applyHeight(this.oldHeight);
    this.operator.viewer.update();
    selectionService.updateGrid();
    oplogEmitter.revert(this.oplogEvents);
  }

  redo(): void {
    this.applyHeight(this.newHeight);
    this.operator.viewer.update();
    selectionService.updateGrid();
    oplogEmitter.reemit(this.oplogEvents);
  }

  dispose(): void {}

  private applyHeight(height: number): void {
    const { module, database } = this.operator.viewer;
    const entityId = findEntityByHandle(module, database, this.handle);
    if (!entityId) return;
    this.operator.setTextHeight(entityId, height);
    deleteObj(entityId);
  }
}
